<section [ngClass]="{'active': active, 'last': isLastStep}">
    <aside>
        @if (done) {
            <span class="icon-done">
                <app-icon name="check" />
            </span>
        }
        @if (active) {
            <span class="icon-active"></span>
        }
        @if (!active && !done) {
            <span class="icon-upcoming"></span>
        }
        <span class="line" [ngClass]="{'done': done}"></span>
    </aside>
    <main>
        <ng-content select="app-timeline-label" />
        @if (active) {
            <div class="content">
                @if (active) {
                    <ng-content />
                }
            </div>
        }
    </main>
</section>
